export * from './datagrid-filter.pipe';


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/shared/index.ts